import { TilesMeta } from '@/scenarios/legacy-player/components/feature-player/types/tiles';

interface CurrentTileProps {
    time: number;
    tiles: TilesMeta[];
}

interface CurrentTileReturnValue {
    modifiedTime: number;
    tile: TilesMeta | null;
}

export const getCurrentTile: (props: CurrentTileProps) => CurrentTileReturnValue = ({
    time,
    tiles,
}) => {
    const tile =
        tiles
            .sort((tile1, tile2) => (tile2.offset ?? 0) - (tile1.offset ?? 0))
            .find((tile) => time >= (tile.offset ?? 0) / 1000) ?? null;

    return {
        modifiedTime: time - (tile?.offset ?? 0) / 1000,
        tile,
    };
};
